// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__SSSiC","containerItemsCenter":"Skeleton_containerItemsCenter__3-2ub"};